import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UserService } from 'src/services/user.service';
import { LocalStorageService } from 'src/app/local-storage.service';

@Component({
  selector: 'app-service-provider-subject-personal-info',
  templateUrl: './service-provider-subject-personal-info.component.html',
  styleUrls: ['./service-provider-subject-personal-info.component.scss']
})
export class ServiceProviderSubjectPersonalInfoComponent implements OnInit {
  @Input() subject: any;
  @Input() familyDossier: any;
  @Input() showDivider: boolean = false;
  @Output() reloadSubject = new EventEmitter();
  isEditMode = false;
  isAssociate = false;
  roleLength: any;
  constructor(private userService: UserService, private localStorageService: LocalStorageService) {
    this.roleLength = JSON.parse(this.localStorageService.get('loggedUser')).role.length;
    this.isAssociate = this.roleLength === 1 ? this.userService.isAssociate() : this.localStorageService.get('primaryRole') === ' Сарадник';
  }

  ngOnInit(): void {
  }

  editSubject() {
    this.isEditMode = true;
  }

  patchSubjectAfterEdit(updatedSubjectId: any) {
    if (updatedSubjectId) {
      this.reloadSubject.emit(updatedSubjectId);
    }
    this.isEditMode = false;
  }

}
